import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, useSortable, arrayMove } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";

export function SortableRow({ id, children, disabled }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, disabled });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.4 : 1 };
  return (
    <tr ref={setNodeRef} style={style} className="border-b border-[#E8E8E6] hover:bg-[#F7F6F3]/50 bg-white group">
      {children({ dragProps: disabled ? null : { ...attributes, ...listeners } })}
    </tr>
  );
}

export function DragHandle({ dragProps }) {
  if (!dragProps) return <span className="w-4" />;
  return (
    <button {...dragProps} className="cursor-grab text-[#B8B6B0] hover:text-[#6B6B6B] touch-none inline-flex mr-1">
      <GripVertical className="w-3.5 h-3.5" />
    </button>
  );
}

export function useDragReorder(items, setItems, onReorder) {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const oldIdx = items.findIndex(i => (i.task_id || i.project_id || i.id) === active.id);
    const newIdx = items.findIndex(i => (i.task_id || i.project_id || i.id) === over.id);
    if (oldIdx === -1 || newIdx === -1) return;
    const reordered = arrayMove(items, oldIdx, newIdx);
    setItems(reordered);
    if (onReorder) onReorder(reordered);
  };

  return { sensors, handleDragEnd, DndContext, SortableContext, verticalListSortingStrategy };
}

export { arrayMove };
